import * as React from 'react';
import { usePackages, usePackagesCheckbox } from './hooks';
import { PublicationFromPackageCheckbox } from './PublicationFromPackageCheckbox';
import { Select } from '@cian/ui-kit/select';
import * as styles from './Packages.container.css';

export const AvailablePackagesContainer = () => {
  const { packages, selectedPackageId, onChange } = usePackages();
  const { checked, disabled, onChange: onCheckboxChange, label } = usePackagesCheckbox();

  const showLabel = packages.length === 1;
  const showPackagesSelect = packages.length > 1 && checked;

  return (
    <div data-testid="PublicationFromPackage">
      <PublicationFromPackageCheckbox
        label={showLabel ? label : ''}
        checked={checked}
        disabled={disabled}
        handleChange={onCheckboxChange}
      />
      {showPackagesSelect && (
        <div className={styles.select}>
          <Select
            value={selectedPackageId}
            size="M"
            options={packages}
            placeholder="Доступные пакеты"
            onChange={onChange}
          />
        </div>
      )}
    </div>
  );
};
